/**
 * Frontend-only types — shapes that exist only in the frontend (SSE protocol
 * and UI-scoped enums).
 */

import type {
  HydratedImage,
  ParameterGroup,
  SuccessResponse,
} from "../generated/api/types.gen";

// ============================================================================
// Server-Sent Events (SSE) — frontend protocol types
// ============================================================================

export interface SSEErrorEvent {
  error: string;
}

export type StreamDoneEvent = "[DONE]";

export function isStreamDone(data: string): data is StreamDoneEvent {
  return data === "[DONE]";
}

/** Second-phase refinement SSE event: auto parameter values re-synced from
 * the rendered image. Hand-written because SSE payloads are not part of the
 * generated OpenAPI client. */
export type ParametersUpdatedEvent = {
  type: "parameters_updated";
  image_id: string;
  parameter_groups: ParameterGroup[];
};

export type RefinementStreamEvent = HydratedImage | ParametersUpdatedEvent;

export function isParametersUpdatedEvent(
  event: RefinementStreamEvent,
): event is ParametersUpdatedEvent {
  return "type" in event && event.type === "parameters_updated";
}

// ============================================================================
// Gallery / session list scoping — UI-only enum
// ============================================================================

/** Filter scope for the paginated /api/sessions endpoint. */
export type SessionListScope = string | "root" | null;

// ============================================================================
// Session management response aliases
// ============================================================================

export type DeleteSessionResponse = SuccessResponse;
export type ClearGalleryResponse = SuccessResponse;
